export const Priority = {
    HIGH: 0,
    LOW: 1,
};
